import $http from './http'
import config from './config'

export default {
    name: 'message',
    getUrl(url) {
        return config.getUrl(this.name, url);
    },
    getmessage(data){
        return $http.post(this.getUrl(`/message/getmessages`),data);
    },
    savemessage(data){
        return $http.post(this.getUrl('/message/added'),data);
    },
    readmsg(id){
        return $http.get(this.getUrl(`/message/ReadMsg/${id}`));
    }
}



// WEBPACK FOOTER //
// ./src/apis/messageApi.js